<template>
	<el-card class="guest-container">
		<template #header>
		  <div class="header">
			  <el-button type="primary" size="small" icon="el-icon-plus" @click="editPoster('')">新增</el-button>
			  <el-button type="warning" size="small" icon="el-icon-plus" @click="updatePosterSort()">更新排序</el-button>
		  </div>
		</template>
		<el-table
		v-loading="loading"
		:data="list"
		tooltip-effect="dark"
		style="width: 100%"
		>
			<el-table-column label="排序" prop="sort_order">
				<template v-slot="scope">
				    <el-input :style="{'width':'40%'}" type="text" v-model="scope.row.sort_order"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="轮播图">
				<template v-slot="scope">
					<el-image class="product-img-small" v-if="scope.row.image" :src="this.getImgPrefix()+scope.row.image"
					 fit="contain" lazy>
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="swiper_url" label="跳转链接"></el-table-column>
			<el-table-column label="开始时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column
			  label="开启状态"
			>
			  <template #default="scope">
					<el-switch
						v-model="scope.row.status"
						active-color="#409EFF"
						inactive-color="#F56C6C"
						:active-value="1"
						:inactive-value="2"
						@change="changeEnabled(scope.row.status, scope.row.id)">
					</el-switch>
			  </template>
			</el-table-column>
			<el-table-column
			  label="操作"
			  width="auto"
			>
			  <template #default="scope">
						  <el-button type="primary" size="mini" @click="editPoster(scope.row)">编辑</el-button>
						  <el-button type="warning" size="mini" @click="delPoster(scope.row)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
	</el-card>	
	<el-dialog title="小海报配置" v-model="dialogFormVisible">
		<div class="col">
			<el-form  label-position="right" label-width="100px" :model="form" ref="form" :rules="rules">
				<el-form-item label="名称" prop="title" >
					<el-input v-model="form.title" size="small" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="跳转链接" prop="swiper_url">
					<el-input v-model="form.swiper_url" size="small" placeholder="跳转链接"></el-input>
				</el-form-item>
				<el-form-item label="图片">
					<upload buttonTitle='上传' upload_path='upload_poster' :resize='750' @success-upload='imgSuccess_SingleFile'></upload>
					<div class="row-no-full" style="flex-wrap: wrap;">
						<div style="margin-right: 30px;">
							<div class="col">
								<div class="demo-image__preview">
									<el-image v-if="form.image && form.image!=''" :src='this.getImgPrefix()+form.image' style='width: 120px;' fit='contain' ></el-image>
								</div>
								<!-- <div class="row-no-full" style="justify-content: space-around">
									<upload buttonTitle="更换" upload_path='upload_banner' type="warning" size="mini" @success-upload='updateThumbImg'
									 :customParams="[i]"></upload>
									<div>
										<el-button type='danger' size='mini' @click='delete_thumb_img(i)'>删除</el-button>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="开始时间" prop="start_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
				<el-form-item label="结束时间" prop="end_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Upload from '../common/Upload.vue'
	export default{
		name: 'PosterList',
		components:{
			Upload,
		},
		data(){
			return{
				loading:true,
				list:[],
				dialogFormVisible:false,
				thumbList:[],
				sort_orders_string:[],
				form:{
					title:'',
					swiper_url:'',
					image:[], 
					start_time:'',
					end_time:'',
					sort_order:0,
					
				},
				rules: {
					title: [{
						required: true,
						message: '请填写名称',
						trigger: 'blur'
					}],
					banner_url: [{
						required: true,
						message: '请填写链接',
						trigger: 'blur'
					}],
					swiper_url: [{
						required: true,
						message: '请填写跳转链接',
						trigger: 'blur'
					}],
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		
		methods:{
			getPosterList(){
				this.httpPost({
					url:'/admin/homeSetting/poster_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res)=>{
					this.loading=false;
					// console.log(res);
					this.list=res.data;
				
				})
			},
			changeEnabled(status, id){
				let select_id = id;
				let change_status = status;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/homeSetting/change_poster_status',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			editPoster(val){
				let temp = this.cloneObj(val);
				if (val) {
					temp.start_time = this.timestampToTime(temp.start_time);
					temp.end_time = this.timestampToTime(temp.end_time);
					this.form = temp;
				} else {
					this.resetObj(this.form);
				}
				
				this.dialogFormVisible=true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			delPoster(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/homeSetting/delPoster",
				  {id:id}).then((res) => {
				  // console.log(data);
							
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.getPosterList();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			updatePosterSort(){
				let ids = [];
				this.sort_orders_string =[];
				this.$confirm('此操作将更新排序, 是否继续?', '提示', {
				                        confirmButtonText: '确定',
				                        cancelButtonText: '取消',
				                        type: 'warning'
				                    }).then((re) => {
				                        for (let i in this.list){
				                            if (this.sort_orders_string.indexOf(this.list[i].sort_order) == '-1'){
				                                //==-1表示该字符串不在此数组,返回值为-1
				                                this.sort_orders_string.push(this.list[i].sort_order);
				                                ids.push({id:this.list[i].id,sort_order:this.list[i].sort_order});
				                            }else{
				                                this.$message.error('排序有重复值');
				                                this.sort_orders_string = [];
				                                return;
				                            }
				                        }
										// console.log(ids);return;
										this.httpPost({
											url:'/admin/homeSetting/updatePosterSort',
											data:ids
										}).then((res)=>{
											if(res.code ==1){
												this.$message.success(res.msg);
												this.getPosterList();
											}
										})
				                    })
			},
			imgSuccess_SingleFile(e) {
			 
			if (this.form.image.length > 0) {
				this.form.image ='';
				// this.form.image.splice(0, 1) //缩略图 每次删掉前一次上传的
			}
			this.form.image=e;
			
			},
			submit(){
				if(this.form.image==''){
					this.$message.error('图片未上传');
					return false;
				} 
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updatePoster();
					}else{
						console.log('error submit!')
						return false;
					}
				})
				
			},
			updatePoster(){
				let id = this.form.id;
				if (!id) id = '';
				this.httpPost({
					url:'/admin/homeSetting/modify_poster?id='+ id,
					data:this.form
				}).then((res)=>{
					if(res.code ==1){
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getPosterList();
					}
				})
			}
		},
		created() {
			this.getPosterList();
		}
	}
</script>

<style>
</style>
